export default function isDateOlderThan(
	date: Date | string,
	days: number
): boolean {
	const targetDate = new Date(date)
	const cutoffDate = new Date()
	cutoffDate.setDate(cutoffDate.getDate() - days)

	return targetDate < cutoffDate
}
